<template>
  <li class="w-full rounded-xl group glow">
    <LangRouterLink :to="showRoute" class="w-full h-full flex flex-col justify-between">
      <div :class="['block px-5 py-5 md:px-8 md:pt-8 md:py-9 transition-[padding]', {'md:px-8 md:pt-8 md:pb-9': grid}]">
        <div class="flex flex-col md:flex-row items-start gap-2.5 md:gap-4">
          <p v-for="purpose in organization.purposes" :key="`organization-${organization.id}-purpose-${purpose}`"
             :class="[`text-sm px-3 py-1.5 overflow-hidden rounded-xl bg-${$purposes_colors[purpose]}-${grid ? 'base' : 'dark'} text-${$purposes_colors[purpose]}-base transition-all`, {'w-2.5 !p-0 aspect-square': grid}]">
            <span :class="['transition-opacity', {'opacity-0': grid}]">{{ $app.data.purposes[purpose].name }}</span>
          </p>
        </div>
        <OrganizationLogo v-if="organization?.logo?.source" :source="organization.logo.source" class="mt-5"/>
        <h2 class="text-2xl md:text-4xl mt-5">{{ organization.name }}</h2>
      </div>
      <Transition name="fade" mode="out-in">
        <div class="flex justify-between items-end" v-if="!grid">
          <div class="flex flex-col md:flex-row gap-8 pl-5 md:pl-9 pb-5 md:pb-9 pr-5 md:pr-12 grow">
            <div class="md:w-[25%] shrink-0 max-h-12 overflow-hidden">
              <p :class="categoryClasses">{{ $t('organization.target_audiences') }}</p>
              <p>{{ slicedTargetAudiences }}</p>
            </div>
            <div class="md:w-[75%] shrink-0 max-h-24 md:max-h-12 overflow-hidden">
              <p :class="categoryClasses">{{ $t('organization.competences') }}</p>
              <p class="leading-6">{{ slicedCompetences }}</p>
            </div>
          </div>
        </div>
        <div v-else class="px-8 pb-8 text-deep-indigo-pale text-sm block leading-6">
          {{ slicedCompetences }}
        </div>
      </Transition>
    </LangRouterLink>
  </li>
</template>

<script>
import {Icon, LangRouterLink} from '@/components/helpers'
import {OrganizationLogo} from '@/components/organization/small'
import {slugify} from '@/helpers'

export default {
  name: 'OrganizationCard',
  components: {Icon, LangRouterLink, OrganizationLogo},
  props: {
    grid: {
      type: Boolean,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: true
    },
    organization: {
      type: Object,
      required: true
    },
    width: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      categoryClasses: 'text-deep-indigo-pale text-sm mb-3',
      categories: {
        competences: '',
        target_audiences: ''
      }
    }
  },
  computed: {
    showRoute() {
      return {
        name: this.$routes.ORGANIZATION.SHOW,
        params: {id: this.organization.id, slug: slugify(this.organization.name)}
      }
    },
    slicedCompetences() {
      const ratio = this.isMobile
          ? 4.5
          : this.grid ? 14 : 13
      return this.sliceString(this.categories.competences, this.width, ratio)
    },
    slicedTargetAudiences() {
      const ratio = this.isMobile
          ? 8
          : 48
      return this.sliceString(this.categories.target_audiences, this.width, ratio)
    }
  },
  methods: {
    setCategories() {
      ['competences', 'target_audiences'].forEach(category => {
        this.categories[category] = this.organization[category]
            .map(categoryId => this.$app.data[category][categoryId].name)
            .join(', ')
      })
    },
    sliceString(string, width, ratio) {
      const sliceWidth = Math.floor(width / ratio)
      if (sliceWidth >= string.length) return string

      const trimmedString = string.slice(0, sliceWidth).trim()

      return `${trimmedString.substring(trimmedString.length - 1) === ',' ? trimmedString.slice(0, trimmedString.length - 2) : trimmedString}...`
    }
  },
  mounted() {
    this.setCategories()
  },
  watch: {
    '$app.data.competences'() {
      this.$nextTick(this.setCategories)
    }
  }
}
</script>